// extracted by mini-css-extract-plugin
export default {"navi_submenu_container":"Navi-submenu-burger_navi_submenu_container__Nc6cV"};